export default __webpack_public_path__ + "static/media/program_intro_9.0009afad.png";